import { ROLEPLAY_SCENARIOS } from '../components/detail-panels/constants';

export const CANDIDATE_SCENARIO_IDS = ['cold_call_hiring_authority'];

export const CANDIDATE_ROLEPLAY_SCENARIOS = ROLEPLAY_SCENARIOS.filter(type => {
  return CANDIDATE_SCENARIO_IDS.includes(type.id);
});

export const JOB_ORDERS_SCENARIO_IDS = ['cold_call_candidate'];

export const JOB_ORDERS_ROLEPLAY_SCENARIOS = ROLEPLAY_SCENARIOS.filter(type => {
  return JOB_ORDERS_SCENARIO_IDS.includes(type.id);
});
